<div id="spinner">
    <div class="bd">
        <div class='image'>
        </div>
        <div class="text">
            {{message}}
        </div>
    </div>
</div>
